/** Code-only registry. Population and URL activation require separate rollout approval.
 * IDs are persisted CharityStack organization IDs, never Clerk IDs or merchant names.
 */
export const doubleTheDonationRollout = Object.freeze({
  key: 'org_engagement_admin_api_cutover_dtd',
  organizations: Object.freeze([] as readonly { organizationId: string; enabled: boolean }[]),
});

export function selectDoubleTheDonationUrl({
  organizationId,
  authorization,
  registry = doubleTheDonationRollout.organizations,
  url = import.meta.env.VITE_APP_ORG_ENGAGEMENT_DTD_URL,
}: {
  organizationId: unknown;
  authorization: string;
  registry?: unknown;
  url?: unknown;
}): string | null {
  try {
    if (typeof organizationId !== 'string' || !organizationId || !Array.isArray(registry))
      return null;
    const seen = new Set<string>();
    let enabled = false;
    for (const row of registry) {
      if (
        !row ||
        typeof row !== 'object' ||
        Object.keys(row).sort().join(',') !== 'enabled,organizationId' ||
        typeof row.organizationId !== 'string' ||
        !row.organizationId ||
        typeof row.enabled !== 'boolean' ||
        seen.has(row.organizationId)
      )
        return null;
      seen.add(row.organizationId);
      if (row.organizationId === organizationId) enabled = row.enabled;
    }
    if (!enabled || typeof url !== 'string' || !url || !authorization) return null;
    const parsed = new URL(url);
    if (
      parsed.protocol !== 'https:' ||
      parsed.username ||
      parsed.password ||
      parsed.search ||
      parsed.hash
    )
      return null;
    return url;
  } catch {
    return null;
  }
}
